import { render, staticRenderFns } from "./envelope-delete-modal.vue?vue&type=template&id=8f6e7520&scoped=true"
import script from "./envelope-delete-modal.vue?vue&type=script&lang=js"
export * from "./envelope-delete-modal.vue?vue&type=script&lang=js"
import style0 from "./envelope-delete-modal.vue?vue&type=style&index=0&id=8f6e7520&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6e7520",
  null
  
)

export default component.exports